import { getBaseUrl, request } from 'src/helper/api';

export const getCalendarDisplayHours = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/settings/calendar/display-hours`,
      contentType: 'json',
      token,
      signal,
    },
    'calendar-settings/getCalendarDisplayHours',
  );

export const updateCalendarDisplayHours = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'PUT',
      url: `${getBaseUrl()}api/settings/calendar/display-hours`,
      contentType: 'json',
      token,
      signal,
    },
    'calendar-settings/updateCalendarDisplayHours',
  );
